import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from "@/libs/api.request";
import { user, home } from "./api_url";
/**
 * 登录接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var login = function login(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.login,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 退出登录
 * @param token
 * @returns {*|{responseURL}}
 */

export var logout = function logout(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.logout,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 注册商家账号
 */

export var register = function register(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.register,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 找回密码
 */

export var Forgot = function Forgot(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.Forgot,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取短信验证码
 */

export var getsms = function getsms(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getsms,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 邮箱获取验证码
 */

export var GetEmall = function GetEmall(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.GetEmall,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取当前用户信息
 * @param token
 * @returns {*|{responseURL}}
 */

export var getUserInfo = function getUserInfo(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getUserInfo,
    data: params,
    method: "post"
  });
};
/**
 * 获取地区省市县
 */

export var getregion = function getregion(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getregion,
    data: params,
    method: "post"
  });
};
/**
 * 修改密码
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */

export var UpdPWD = function UpdPWD(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.UpdPWD,
    data: params,
    method: "post"
  });
};
/**
 * 修改查看工资密码
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */

export var UpdPWDWage = function UpdPWDWage(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.UpdPWDWage,
    data: params,
    method: "post"
  });
};
/**
 * 设置登录人座右铭
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */

export var SetMotto = function SetMotto(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.SetMotto,
    data: params,
    method: "post"
  });
};
export var getUnreadCount = function getUnreadCount() {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/count",
    method: "get"
  });
};
export var getMessage = function getMessage() {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/init",
    method: "get"
  });
};
export var getContentByMsgId = function getContentByMsgId(msg_id) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/content",
    method: "get",
    params: {
      msg_id: msg_id
    }
  });
};
export var hasRead = function hasRead(msg_id) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/has_read",
    method: "post",
    data: {
      msg_id: msg_id
    }
  });
};
export var removeReaded = function removeReaded(msg_id) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/remove_readed",
    method: "post",
    data: {
      msg_id: msg_id
    }
  });
};
export var restoreTrash = function restoreTrash(msg_id) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/restore",
    method: "post",
    data: {
      msg_id: msg_id
    }
  });
};
/**
 * 获取菜单
 * @param params
 * @returns {*|{responseURL}}
 */

export var login_success_permission = function login_success_permission(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.login_success_permission,
    method: "get",
    params: params
  });
};
/**
 * 设置头像
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */

export var SetAvatar = function SetAvatar(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.SetAvatar,
    method: "post",
    data: params
  });
};
/**
 * savebaseinfo //保存基本信息
 */

export var savebaseinfo = function savebaseinfo(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.savebaseinfo,
    method: "post",
    data: params
  });
};
/**
 * 19.实名认证
 * @param params
 * @returns {*}
 */

export var real_name_auth = function real_name_auth(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.real_name_auth,
    method: "post",
    data: data
  });
};
/**
 * 20.企业认证
 * @param params
 * @returns {*}
 */

export var enterprise = function enterprise(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.enterprise,
    method: "post",
    data: data
  });
};
/**
 * changeaccount 变更账号
 */

export var changeaccount = function changeaccount(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.changeaccount,
    method: "post",
    data: params
  });
};
/**
 * 企业认证倒计时
 * @param params
 * @returns {*}
 */

export var enterprise_audit_count_down = function enterprise_audit_count_down(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.enterprise_audit_count_down,
    method: "post",
    data: params
  });
};
/**
 * 实名认证倒计时
 * @param params
 * @returns {*}
 */

export var realname_audit_count_downr = function realname_audit_count_downr(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.realname_audit_count_downr,
    method: "post",
    data: params
  });
};
/**
 * 首页总览统计数据
 * @param params
 * @returns {*}
 */

export var index_overview = function index_overview(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.index_overview,
    method: "post",
    data: params
  });
};
/**
 * 服务统计数据
 * @param params
 * @returns {*}
 */

export var service_overview = function service_overview(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.service_overview,
    method: "post",
    data: params
  });
};
/**
 * 用户统计数据
 * @param params
 * @returns {*}
 */

export var user_overview = function user_overview(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.user_overview,
    method: "post",
    data: params
  });
};
/**
 * 产品统计数据
 * @param params
 * @returns {*}
 */

export var product_overview = function product_overview(params) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.product_overview,
    method: "post",
    data: params
  });
};